<template>
  <div class="scence usercenterRolemanageIndex">
    <div class="content">
      <div class="skt" ref="skt">
        <div class="select">
          <span class="xzqh">角色名称:</span>
          <div class="selcountry">
            <el-input
              placeholder="搜索角色名称"
              v-model="query.searchName"
              @keyup.enter.native="onLoadData"
              class="filter-item"
              style="width: 150px"
              clearable
              @change="Global.emptyQuery(query.searchName, onLoadData)"
            ></el-input>
          </div>
          <span class="search" @click="onLoadData">查询</span>
          <span v-if="allowsPerm.insert" class="add" @click="onAdd"
            ><span class="add-icon"></span>新增</span
          >
        </div>
        <div class="tablebox">
          <div class="fzxxtable">
            <el-table
              :data="roles"
              border
              fit
              highlight-current-row
              :max-height="height"
              style="width: 100%"
            >
              <el-table-column
                type="index"
                width="80"
                align="center"
                label="序号"
              ></el-table-column>
              <el-table-column
                align="center"
                label="角色分组"
                prop="groupName"
              ></el-table-column>
              <el-table-column
                align="center"
                label="角色名称"
                prop="name"
              ></el-table-column>
              <el-table-column
                align="center"
                label="角色描述"
                prop="desc"
              ></el-table-column>
              <el-table-column align="center" width="220" label="操作">
                <template slot-scope="scope">
                  <div class="operation">
                    <span
                      v-if="allowsPerm.delete"
                      class="del"
                      @click="onDelete(scope.row)"
                      ><span class="del-icon"></span>删除</span
                    >
                    <span
                      v-if="allowsPerm.update"
                      class="edit"
                      @click="onEdit(scope.row)"
                      ><span class="edit-icon"></span>编辑</span
                    >
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <el-dialog
          :title="diagTitle"
          :visible.sync="diagShow"
          :close-on-click-modal="false"
          width="54%"
        >
          <el-form
            ref="roleForm"
            :rules="rules"
            :model="currentRole"
            label-width="100px"
          >
            <div class="formContent">
              <div class="leftDiv">
                <el-form-item label="角色名称" required prop="name">
                  <el-input
                    v-model="currentRole.name"
                    placeholder="请输入角色名称"
                  ></el-input>
                </el-form-item>
                <el-form-item label="角色分组" required prop="roleGroupId">
                  <el-cascader
                    v-model="currentRole.roleGroupId"
                    :options="roleGroups"
                    :props="{
                      expandTrigger: 'hover',
                      label: 'name',
                      value: 'id',
                    }"
                    :show-all-levels="false"
                  >
                  </el-cascader>
                </el-form-item>
                <el-form-item label="角色描述">
                  <el-input
                    v-model="currentRole.desc"
                    placeholder="角色描述信息"
                  ></el-input>
                </el-form-item>
              </div>

              <div class="rightDiv">
                <el-form-item label="角色授权">
                  <el-tree
                    ref="permissionTree"
                    node-key="key"
                    :indent="8"
                    :expand-on-click-node="false"
                    :props="defaultProps"
                    :show-checkbox="true"
                    :check-on-click-node="true"
                    :highlight-current="true"
                    :default-expand-all="true"
                    :data="permissionGroups"
                    @check="currentChange"
                  >
                    <span class="custom-tree-node" slot-scope="{ node, data }">
                      <span v-if="data.type !== 'permission'">
                        {{ node.label }}
                      </span>
                      <span v-else>
                        <i class="el-icon-setting" style="color: #409eff"></i>
                        <span
                          style="color: #409eff"
                          :title="data.desc || data.name"
                          >{{ node.label }}</span
                        >
                      </span>
                    </span>
                  </el-tree>
                </el-form-item>
              </div>
            </div>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="diagShow = false">取消</el-button>
            <el-button type="primary" @click="onSave">保存</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import accountTypes from '@/store/types/account'
import appTypes from '@/store/types/app'
import { Pager, SelectTree } from '@/components'

export default {
  components: {
    Pager,
    SelectTree
  },
  data () {
    return {
      height: 10,
      loading: false,
      diagShow: false,
      diagTitle: '新增组织',
      groupDiagShow: false,
      groupDiagTitle: '新增分组',
      query: {
        searchName: '',
        roleGroupId: '',
        pageIndex: 1,
        pageSize: 20
      },
      defaultProps: {
        label: 'name',
        children: 'children'
      },
      total: 0,
      currentRole: {},
      currentGroup: {},
      roles: [],
      allRoles: [],
      roleGroups: [],
      permissionGroups: [],
      rules: {
        name: [{ required: true, message: '角色名称必填' }],
        roleGroupId: [{ required: true, message: '角色分组必须设置' }]
      }
    }
  },
  methods: {
    onLoadData () {
      this.loading = true
      this.$store
        .dispatch(accountTypes.GET_ROLES, {
          roleGroupId: this.query.roleGroupId,
          searchName: this.query.searchName
        })
        .then((data) => {
          this.total = data.total
          this.roles = data.results
          this.allRoles = data.results
          this.loading = false
        })
    },
    loadPermissionGroups () {
      this.$store
        .dispatch(accountTypes.GET_PERMISSIONGROUPS, { withPermission: true })
        .then((groups) => {
          this.permissionGroups = groups
        })
    },
    loadRoleGroups () {
      this.$store.dispatch(accountTypes.GET_ROLEGROUPS, {}).then(groups => {
        this.roleGroups = groups
        this.delChild(this.roleGroups)
      })
    },
    delChild (arr) {
      for (let i = 0; i < arr.length; i++) {
        const el = arr[i]
        if (el.children.length > 0) {
          this.delChild(el.children)
        } else {
          delete el['children']
        }
      }
    },
    onNodeClick (data) {
      this.query.roleGroupId = data.id
      this.onLoadData()
    },
    onCurrentChange (pageIndex) {
      this.query.pageIndex = pageIndex
      this.roles = this.allRoles.slice(
        (this.query.pageIndex - 1) * this.query.pageSize,
        this.query.pageIndex * this.query.pageSize
      )
    },
    onSizeChange (pageSize) {
      this.query.pageIndex = 1
      this.query.pagesize = pageSize
      this.roles = this.allRoles.slice(
        (this.query.pageIndex - 1) * this.query.pageSize,
        this.query.pageIndex * this.query.pageSize
      )
    },
    onAdd () {
      SelectTree.onlyLeaf = false
      if (this.permissionGroups.length === 0) {
        this.loadPermissionGroups()
      }
      this.diagTitle = '新增角色'
      this.currentRole = { roleGroupId: this.query.roleGroupId }
      this.diagShow = true
      this.$nextTick(() => {
        this.$refs.permissionTree.setCheckedKeys([])
      })
      this.Global.clearValidate(this, 'roleForm')
    },
    onEdit (row) {
      if (this.permissionGroups.length === 0) {
        this.loadPermissionGroups()
      }
      this.diagTitle = '编辑角色'
      this.currentRole = Object.assign({}, row)
      this.diagShow = true
      this.Global.clearValidate(this, 'roleForm')
      this.$nextTick(() => {
        this.$refs.permissionTree.setCheckedKeys(
          this.currentRole.permissionIds
        )
      })
    },
    onDelete (row) {
      this.$confirm(`确定要删除角色 '${row.name}' 吗?`, '确认')
        .then(() => {
          this.loading = true
          this.$store
            .dispatch(accountTypes.DELETE_ROLE, { id: row.id })
            .then(() => {
              this.loading = false
              this.$notify.success({ title: '成功', message: '删除角色成功.' })
              this.onLoadData()
            })
            .catch(() => {
              this.loading = false
            })
        })
        .catch(() => {})
    },
    onSave () {
      var permissionIds = this.$refs.permissionTree
        .getCheckedNodes(false, true)
        .filter((x) => x.type === 'permission' || x.type === 'main-permission')
        .map((x) => x.id)
      if (permissionIds.length === 0) {
        this.$notify.error({
          title: '提示',
          message: '请选择角色相关的授权项。'
        })
        return
      }
      this.currentRole.permissionIds = permissionIds
      let currentRole = JSON.parse(JSON.stringify(this.currentRole))
      if (currentRole.roleGroupId instanceof Array) {
        currentRole.roleGroupId = currentRole.roleGroupId[currentRole.roleGroupId.length - 1]
      }
      this.$refs['roleForm'].validate((valid) => {
        if (valid) {
          this.loading = true
          this.$store
            .dispatch(accountTypes.SAVE_ROLE, currentRole)
            .then(() => {
              this.loading = false
              this.diagShow = false
              this.$notify.success({ title: '成功', message: '保存角色成功.' })
              this.query.roleGroupId = currentRole.roleGroupId
              this.onLoadData()
            })
            .catch(() => {
              this.loading = false
            })
        }
      })
    },
    currentChange (item, node) {
      var nodeSearch = this.$refs.permissionTree.getNode(item.key)
      if (!nodeSearch.checked) {
        if (item.meta === 'search') {
          var siblingIds = this.$refs.permissionTree
            .getCheckedNodes(true, true)
            .filter(
              (x) =>
                x.type === 'permission' &&
                x.permissionGroupId === item.permissionGroupId
            )
            .map((x) => x.id)
          if (siblingIds != null && siblingIds.length > 0) {
            console.log(siblingIds)
            siblingIds.forEach((item) => {
              this.$refs.permissionTree.setChecked(item, false, false)
            })
          }
        }
      }
    }
  },
  computed: {
    allowsPerm: {
      get () {
        return this.$store.state.allowPerm
      },
      set () {
        this.$store.dispatch('setAllowPerm', {
          name: this.$route.meta,
          type: this.$route.name
        })
      }
    }
  },
  created () {
    this.$store.dispatch('setAllowPerm', {
      name: this.$route.meta,
      type: this.$route.name
    })
    this.loadRoleGroups()
    this.onLoadData()
  },
  mounted () {
    this.$store.dispatch(appTypes.SET_BREADCRUMB, {
      type: 'app',
      route: {
        path: '/app/index',
        meta: { title: '应用管理' }
      }
    })
    this.$nextTick(() => {
      let selectDiv = document.getElementsByClassName('select')
      this.height =
        this.$refs['skt'].offsetHeight - 20 - selectDiv[0].offsetHeight
    })
  }
}
</script>
<style lang="less" src="@/assets/usercenter.less" scoped></style>
<style lang="less" scoped>
.usercenterRolemanageIndex {
  .formContent {
    display: flex;
    justify-content: space-between;
    &>div:nth-child(1){
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
    .leftDiv{
      flex:2;
      height: 320px;
    }
    .rightDiv{
      flex:3;
      height: 500px;
      /deep/ .el-tree{
        height: 500px;
        overflow: auto;
        .el-tree-node__children{
          .el-tree-node__children{
            .el-tree-node__children{
              display: flex;
            }
          }
        }
      }
    }
    /deep/ .el-cascader{
      width: 100%!important;
    }
  }
}
</style>
